export var removeQueryString = function removeQueryString(url) {
  return url.replace(/\?.+$/, '');
};